var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIconL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 6.89961V1.99961C18.6667 1.22961 18.0667 0.599609 17.3333 0.599609H1.33333C0.6 0.599609 0 1.22961 0 1.99961V15.9996C0 16.7696 0.6 17.3996 1.33333 17.3996H17.3333C18.0667 17.3996 18.6667 16.7696 18.6667 15.9996V11.0996L24 16.6996V1.29961L18.6667 6.89961Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIconL);
export default __webpack_public_path__ + "static/media/videoIconL.cc8f588a892f05336017c42776f4cd1b.svg";
export { ForwardRef as ReactComponent };